
import { Vue, Component } from 'vue-property-decorator'

import notif_service from '@/modules/notifications'

import b64DecodeUnicode from '@/lib/parseBase64';

@Component
export default class FastNotification extends Vue {
  get fast_notifications() {
    return notif_service.fast_notifications
  }
  
  async routePushLink(address: string, id: string) {

    try {

      this.$router.push(address)
      await this.closeNotif(id);
      
    } catch (err) {
      // this.$toast.add({
      //   severity: "error",
      //   summary: "Something wrong!",
      //   detail: err,
      //   life: 4000,
      // })
    }
  }

  async clearTimeoutClick(id: string) {
    notif_service.clearNotifTimeout(id)
  }

  async closeNotif(id: string) {
    console.log('Close notif', id)
    notif_service.removeReadEvent([id])
    // try {
      // await notif_service.readEvent([id])
      // notif_service.setReadEvents([id])
      // notif_service.removeReadEvent([id])
    // } catch (err) {
      // this.$toast.add({
      //   severity: "error",
      //   summary: "Something wrong!",
      //   detail: err,
      //   life: 4000,
      // })
    // }
  }
  b64DecodeUnicode(str: string) {
    return decodeURIComponent(atob(str).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  }

  decodeNotifyBody(str: string) {
    return b64DecodeUnicode(str);
  }

  created(){
    console.log('created!!!!');
  }
}
